export const ReloadTypes = Object.freeze({
  // 強制リロード
  FORCE: 'FORCE',
  // 任意リロード
  OPTION: 'OPTION',
  // リロードしない。デフォルト
  NONE: 'NONE',
})
